module.exports = "/images/backgroundWhite.svg";